(() => {
  const ORDERS_QUERY_NAME = 'query-ordersByEmail';

  const fetchOrders = ({ partnerUuid, token }) => {
    const {
      GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY,
    } = ORDER_TRADE_IN_RESULTS_LOADER;
    const query = `
      query ordersByEmail(
        $partnerUuid: String!
        $token: String!
      ) {
        ordersByEmail(partnerUuid: $partnerUuid, token: $token) {
          commercePlatform
          externalOrderNumber
          orderItems {
            inventoryItem {
              catalogItem {
                title
              }
              color {
                displayName
              }
              images {
                url
              }
            }
            yPackage {
              state
            }
          }
          orderPlacedAt
          state
          uuid
          uuidPrefix
        }
        ${GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY}
      }
    `;

    return fetchWithAppName(
      `${global.url}${ORDERS_QUERY_NAME}`,
      {
        body: JSON.stringify({
          query,
          variables: {
            partnerUuid,
            token,
          },
        }),
      },
    );
  };

  class OrderLookupResultsList extends HTMLElement {
    async loadResults() {
      const { loadResults } = ORDER_TRADE_IN_RESULTS_LOADER;
      const orders = Shopify.designMode ?
        // Display the empty results version of the page in the Shopify theme editor
        [] :
        (await loadResults(ORDERS_QUERY_NAME, fetchOrders)).ordersByEmail;

      this.replaceChildren();

      if (orders?.length > 0) {
        this._renderOrders(orders);
      } else if (orders?.length === 0) {
        this._renderNoOrders();
      }
    }

    _renderOrders(orders) {
      const { orderLookupResult } = ORDER_LOOKUP_RESULT;
      orders.forEach((order) => {
        this.appendChild(orderLookupResult(order));
      });
    }

    _renderNoOrders() {
      const { orderTradeInResultsEmptyState } = ORDER_TRADE_IN_RESULTS_EMPTY_STATE;
      this.appendChild(orderTradeInResultsEmptyState());
    }
  }

  if (!customElements.get('order-lookup-results-list')) {
    customElements.define('order-lookup-results-list', OrderLookupResultsList);
  }
})();
